<script>
import { isComponent } from '@/v-shop/autoloader'
import checkoutMixin from '@/v-shop/checkout/checkout-mixin'
import { loadScript, unloadScript } from '@/utils/load-script'

const recaptchaScript = 'https://www.google.com/recaptcha/api.js'

export default {
	lang: 'shop',
	mixins: [checkoutMixin],
	data() {
		return {
			numero1: '',
			numero2: '',
			tipoDocumento: null,
			documento: '',
			recaptchaPublicKey: null,
			pagarCuotaLink: null,
		}
	},
	computed: {
		canSubmit() {
			const isNumero =
				process.env.NODE_ENV === 'development' || window.location.href.includes('devdrubbit')
					? String(this.numero1 || '').trim() || String(this.numero2 || '').trim()
					: String(this.numero1 || '').trim() && String(this.numero2 || '').trim()

			return !!(isNumero && this.tipoDocumento && this.documento)
		},
	},
	methods: {
		async submitNoCode() {
			await this.checkout.stepSubmit({
				noCode: true,
				numero: this.getNumero(),
				tipoDocumento: this.tipoDocumento,
				documento: this.documento,
			})
		},
		async submit() {
			const response = await this.checkout.stepSubmit({
				numero: this.getNumero(),
				tipoDocumento: this.tipoDocumento,
				documento: this.documento,
				captcha: window.grecaptcha.getResponse(),
			})

			let pagarCuotaLink = null
			if (!response.success) {
				window.grecaptcha.reset()
				if (response.validation.pagarCuotaLink) {
					pagarCuotaLink = response.validation.pagarCuotaLink
				}
			}
			this.pagarCuotaLink = pagarCuotaLink
		},
		openLink() {
			window.open(this.pagarCuotaLink, '_blank')
		},
		setNumeroFields(numero) {
			this.numero1 = numero.slice(0, -1)
			this.numero2 = numero.slice(-1)
		},
		getNumero() {
			return `${this.numero1 || ''}${this.numero2 || ''}`
		},
	},
	mounted() {
		const { recaptchaPublicKey, bVipSocios = [] } = this.checkout.stepViewData || {}

		if (recaptchaPublicKey) {
			this.recaptchaPublicKey = recaptchaPublicKey
			this.$nextTick(() => {
				loadScript(recaptchaScript)
			})
		}

		const payload = this.checkout.stepsData.bvip.payload
		if (payload?.numero) {
			this.setNumeroFields(payload.numero || '')
			this.tipoDocumento = payload.tipoDocumento || ''
			this.documento = payload.documento || ''
		} else if (bVipSocios[0]) {
			this.setNumeroFields(bVipSocios[0].numero || '')
			this.tipoDocumento = bVipSocios[0].tipoDocumento
			this.documento = bVipSocios[0].documento
		}
	},
	beforeDestroy() {
		unloadScript(recaptchaScript)
	},
}
</script>

<template>
	<div>
		<div class="pb-8 text-center"><b>Ingresa tus datos de Socio para obtener descuentos especiales</b></div>
		<div class="d-flex flex-column" style="gap: 24px">
			<div class="d-flex flex-column w100" style="gap: 24px; max-width: 440px; margin: 0 auto">
				<div class="d-flex align-start w100" style="gap: 16px">
					<TextField
						v-model="numero1"
						style="width: 100%"
						label="Número de Socio"
						placeholder="XXXXXXXXXXX"
						:error-messages="checkout.validation.numero"
						outlined
						dense
					/>
					<div class="flex-shrink-0" style="line-height: 40px">&#8212;</div>
					<TextField
						class="flex-shrink-0"
						style="width: 60px"
						v-model="numero2"
						placeholder="X"
						:error-messages="checkout.validation.numero ? ' ' : null"
						outlined
						dense
						maxlength="1"
					/>
				</div>
				<div class="d-flex" style="gap: 24px">
					<Select
						style="max-width: 220px"
						v-model="tipoDocumento"
						label="Tipo"
						:items="[
							{ value: 'DNI', text: 'DNI' },
							{ value: 'PASA', text: 'Pasaporte' },
							{ value: 'LE', text: 'Libreta de Enrolamiento' },
							{ value: 'LC', text: 'Libreta Cívica' },
							{ value: 'CI', text: 'Cédula de Identidad' },
						]"
						:error-messages="checkout.validation.tipoDocumento"
						outlined
						dense
					/>
					<TextField
						v-model="documento"
						label="Número de Documento"
						placeholder="12345678"
						:error-messages="checkout.validation.documento"
						outlined
						dense
					/>
				</div>
			</div>

			<!-- captcha -->
			<div class="d-flex flex-column justify-center align-center text-center" style="height: 88px">
				<div v-if="checkout.validation.captcha" class="font-0 pb-2" style="color: red">
					<b> Por favor, complete el captcha para continuar.</b>
				</div>
				<div class="g-recaptcha" :data-sitekey="recaptchaPublicKey"></div>
			</div>

			<div class="red darken-3 rounded pa-4 text-center" v-if="pagarCuotaLink">
				<div class="pb-2 white--text">
					<b>Paga la cuota y ponte al día para acceder a todos los beneficios</b>
				</div>
				<div class="d-flex align-center justify-center" style="gap: 16px">
					<Button @click="openLink" class="white black--text"> Pagar Cuota Ahora </Button>
					<Button @click="submitNoCode" color="white" outlined small> Continuar sin beneficios </Button>
				</div>
			</div>

			<div class="d-flex align-center pt-3" style="gap: 24px">
				<Button @click="submitNoCode" color="grey darken-3" outlined>
					{{ 'No soy socio' | lang }}
				</Button>
				<Button @click="submit" color="success" class="flex-grow-1" :disabled="!canSubmit">
					{{ 'Validar Socio' | lang }}
				</Button>
			</div>
		</div>
	</div>
</template>

